import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import './styles/index.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('O elemento #root não existe em index.html.');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
